import { render, staticRenderFns } from "./group-reveal.vue?vue&type=template&id=8336c566&scoped=true&"
import script from "./group-reveal.vue?vue&type=script&lang=js&"
export * from "./group-reveal.vue?vue&type=script&lang=js&"
import style0 from "./group-reveal.vue?vue&type=style&index=0&id=8336c566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8336c566",
  null
  
)

export default component.exports